import React from 'react';
import moment from 'moment';
import { Modal } from 'hyperdb-utils';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { ConfirmModal } from 'hyperdb-utils';
import SeasonalPricesForm from './SeasonalPricesForm';
import ModalSeasonsConflict from './ModalSeasonsConflict';

class SeasonalPrices extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const props = this.props;
    return (
      <div>
        <div className="box-header">
          <span>
            <b>Seasons</b>
            &nbsp;
            <button type="button" className="btn btn-xs btn-primary" onClick={ this.handleToggleModal.bind(this, true, -1) }>Add</button>
          </span>
        </div>
        <div className="table-responsive no-padding">
          <table className="table table-hover table-striped table-bordered table-responsive">
            <thead>
              <tr>
                <th>From</th>
                <th>To</th>
                <th>Base price</th>
                <th>Base extra</th>
                <th>Options</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {
                (props.prices).map((price, i) => {
                  if (!shouldDisplay(price) || price.deleted) return null;
                  return (
                    <tr key={ i }>
                      <td>{ price.date_start }</td>
                      <td>{ price.date_end }</td>
                      <td>{ price.base_price }</td>
                      <td>{ price.base_extra }</td>
                      <td>
                        { hasLOS(price) ? 'LOS' : '' }
                        &nbsp;{ hasEGP(price) ? 'EGP' : '' }
                      </td>
                      <td>
                        <DropdownButton title={ <span><i className="fas fa-caret" /> Actions</span> } pullRight bsSize="small" id="Menu actions">
                          <MenuItem onClick={ this.handleToggleModal.bind(this, true, i) }>Edit</MenuItem>
                          <MenuItem onClick={ this.handleOnDupliacte.bind(this, i) }>Duplicate</MenuItem>
                          <MenuItem onClick={ this.handleToggleModalDelete.bind(this, i) }>Delete</MenuItem>
                        </DropdownButton>
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
        {
          this.state.showModalSeasonalPricesForm
            ? <Modal title="Seasonal price" onClose={ this.handleToggleModal.bind(this, false) } onAccept={ handleSubmitPrice.bind(this, this.props.onChange, false) }>
                <SeasonalPricesForm
                  property={ props.property }
                  seasonalPrice={ this.state.editedSeasonalPrice }
                  onChange={ handleChangePrice.bind(this) }
                  errorDates={ this.state.errorDates }
                />
              </Modal>
            : null
        }
        {
          this.state.showModalDeleteSeasonalPrice
            ? <ConfirmModal title="Delete seasonal price" onClose={ this.handleToggleModalDelete.bind(this, -1)} onConfirm={ this.handleDeletePrice.bind(this) }>
                Delete this seasonal price ?
              </ConfirmModal>
            : null
        }
        {
          this.props.showModalConflict
            ? <ModalSeasonsConflict
                close={ this.props.toggleModalConflict.bind(this, false) }
                items={ this.props.prices }
                indexesSeasonsInConflict={ this.props.indexesSeasonsInConflict }
                overwrite={ overwrite.bind(this, this.props.onChange) }
                fillGaps={ fillGaps.bind(this, this.props.onChange) }
              />
            : null
        }
      </div>
    );
  }

  handleToggleModal(bool, indexEditedSeasonalPrice = -1) {
    const editedSeasonalPrice = bool && indexEditedSeasonalPrice !== -1
      ? { ...this.props.prices[indexEditedSeasonalPrice] }
      : {};
    this.setState({ showModalSeasonalPricesForm: bool, indexEditedSeasonalPrice, editedSeasonalPrice, errorDates: false });
  }
  handleOnDupliacte(index) {
    const seasonalPrice = { ...this.props.prices[index] };
    seasonalPrice.date_start = null;
    seasonalPrice.date_end = null;
    this.setState({ showModalSeasonalPricesForm: true, indexEditedSeasonalPrice: -1, editedSeasonalPrice: seasonalPrice, errorDates: false });
  }
  handleToggleModalDelete(indexDeleteSeasonalPrice = -1) {
    const showModalDeleteSeasonalPrice = indexDeleteSeasonalPrice !== -1;
    this.setState({ showModalDeleteSeasonalPrice, indexDeleteSeasonalPrice });
  }
  handleDeletePrice() {
    const index = this.state.indexDeleteSeasonalPrice;
    if (index !== -1) {
      const prices = (this.props.prices).slice();
      prices[index] = removeSeasonalPrice(this.props, prices[index]);
      handleChangeSeasonalPrices(this.props.onChange, prices);
    }
    this.handleToggleModalDelete(-1);
  }
}

function shouldDisplay(price) {
  if (!price.date_start || !price.date_end) return true;
  const start = moment().startOf('year').format('YYYY-MM-DD');
  return price.date_end >= start;
}
function sortedSeasonalPrices(prices) {
  return (prices).slice().sort((a, b) => {
    return (a.date_start || '').localeCompare(b.date_start || '');
  });
}
function hasLOS(price) {
  return (price.variations_for_min_nights || []).length > 0;
}
function hasEGP(price) {
  return (price.extra_for_extra_guests || []).length > 0;
}

export function handleChangePrice(attributeName, field) {
  const { name, value } = field;
  const editedSeasonalPrice = { ...this.state.editedSeasonalPrice, [attributeName]: value };
  this.setState({ editedSeasonalPrice });
}
export function handleSubmitPrice(onChangePrices, fromCalendar = false) {
  const prices = (this.props.prices).slice();
  const { editedSeasonalPrice, indexEditedSeasonalPrice } = this.state;
  if (editedSeasonalPrice.date_start && editedSeasonalPrice.date_end && editedSeasonalPrice.base_price) {
    // Dates correct
    if (moment(editedSeasonalPrice.date_end).isSameOrAfter(editedSeasonalPrice.date_start)) {
      const indexesSeasonsInConflict = getIndexesSeasonsInConflict(prices, editedSeasonalPrice, indexEditedSeasonalPrice);
      if (indexesSeasonsInConflict.length > 0) {
        // Conflict with other seasons
        const toggleModalConflict = fromCalendar ? this.props.toggleModalConflictPrices : this.props.toggleModalConflict;
        toggleModalConflict(true, indexesSeasonsInConflict);
      } else {
        // Save
        saveSeasonalPrice(this.props, prices, editedSeasonalPrice, indexEditedSeasonalPrice);
        handleChangeSeasonalPrices(onChangePrices, prices);
        this.setState({ showModalSeasonalPricesForm: false, indexEditedSeasonalPrice: -1, editedSeasonalPrice: {}, errorDates: false });
      }
    } else {
      // Error dates
      this.setState({ errorDates: true });
    }
  }
}

export function overwrite(onChangePrices) {
  const props = this.props;
  const prices = props.prices.slice();
  const editedSeasonalPrice = this.state.editedSeasonalPrice;
  // Overwrite seasons
  props.indexesSeasonsInConflict.forEach(index => {
    const seasonalPrice = { ...props.prices[index] };
    if (moment(seasonalPrice.date_end).isBetween(editedSeasonalPrice.date_start, editedSeasonalPrice.date_end, null, '[]')) {
      // Change end date
      if (moment(seasonalPrice.date_start).isBefore(editedSeasonalPrice.date_start)) {
        seasonalPrice.date_end = moment(editedSeasonalPrice.date_start).subtract(1, 'day').format('YYYY-MM-DD');
        prices[index] = seasonalPrice;
      } else {
        // Remove season
        prices[index] = removeSeasonalPrice(props, prices[index]);
      }
    } else if (moment(seasonalPrice.date_start).isBetween(editedSeasonalPrice.date_start, editedSeasonalPrice.date_end, null, '[]')) {
      // Change begin date
      if (moment(seasonalPrice.date_end).isAfter(editedSeasonalPrice.date_end)) {
        seasonalPrice.date_start = moment(editedSeasonalPrice.date_end).add(1, 'day').format('YYYY-MM-DD');
        prices[index] = seasonalPrice;
      } else {
        // Remove season
        prices[index] = removeSeasonalPrice(props, prices[index]);
      }
    } else {
      // Split season
      const copiedSeason = { ...seasonalPrice, date_end: moment(editedSeasonalPrice.date_start).subtract(1, 'day').format('YYYY-MM-DD') };
      saveSeasonalPrice(props, prices, copiedSeason, -1, false);
      seasonalPrice.date_start = moment(editedSeasonalPrice.date_end).add(1, 'day').format('YYYY-MM-DD');
      prices[index] = seasonalPrice;
    }
  });
  // Save
  saveSeasonalPrice(props, prices, editedSeasonalPrice, this.state.indexEditedSeasonalPrice);
  handleChangeSeasonalPrices(onChangePrices, prices);
  this.setState({ showModalSeasonalPricesForm: false, indexEditedSeasonalPrice: -1, editedSeasonalPrice: {}, errorDates: false });
}
export function fillGaps(onChangePrices) {
  const props = this.props;
  const prices = props.prices.slice();
  const editedSeasonalPrice = this.state.editedSeasonalPrice;
  // Fill gap before first season
  const firstSeason = prices[props.indexesSeasonsInConflict[0]];
  if (moment(editedSeasonalPrice.date_start).isBefore(firstSeason.date_start)) {
    saveSeasonalPrice(props, prices, { ...editedSeasonalPrice, date_end: moment(firstSeason.date_start).subtract(1, 'day').format('YYYY-MM-DD') });
  }
  // Fill gap after last season
  const lastSeason = prices[props.indexesSeasonsInConflict.slice(-1)[0]];
  if (moment(editedSeasonalPrice.date_end).isAfter(lastSeason.date_end)) {
    saveSeasonalPrice(props, prices, { ...editedSeasonalPrice, date_start: moment(lastSeason.date_end).add(1, 'day').format('YYYY-MM-DD') });
  }
  // Fill gap between seasons
  if (props.indexesSeasonsInConflict.length >= 2) {
    let previousSeasonEndDate;
    props.indexesSeasonsInConflict.forEach(index => {
      const seasonalPrice = prices[index];
      if (index > 0 && moment(previousSeasonEndDate).add(1, 'day').isBefore(seasonalPrice.date_start)) {
        saveSeasonalPrice(props, prices, { ...editedSeasonalPrice, date_start: moment(previousSeasonEndDate).add(1, 'day').format('YYYY-MM-DD'), date_end: moment(seasonalPrice.date_start).subtract(1, 'day').format('YYYY-MM-DD') });
      }
      previousSeasonEndDate = seasonalPrice.date_end;
    });
  }
  // Save
  handleChangeSeasonalPrices(onChangePrices, prices);
  this.setState({ showModalSeasonalPricesForm: false, indexEditedSeasonalPrice: -1, editedSeasonalPrice: {}, errorDates: false });
}

function saveSeasonalPrice(props, prices, seasonalPrice, index = -1, setSynchronisation = true) {
  let _price = seasonalPrice;
  if (index === -1 || index === null || index === undefined) {
    prices.push({ ...seasonalPrice, id: prices.length + 1 });
  } else {
    _price = { ...prices[index] };
    prices[index] = seasonalPrice;
  }
  if (setSynchronisation && props.setSeasonalPriceSynchronisation) {
    props.setSeasonalPriceSynchronisation(_price);
  }
}
function removeSeasonalPrice(props, seasonalPrice) {
  if (props.setSeasonalPriceSynchronisation) {
    props.setSeasonalPriceSynchronisation(seasonalPrice);
  }
  return { ...seasonalPrice, deleted: true };
}
function handleChangeSeasonalPrices(onChange, prices) {
  onChange({ value: sortedSeasonalPrices(prices.filter(p => !!p)) });
}

function getIndexesSeasonsInConflict(prices, editedSeasonalPrice, indexEditedSeasonalPrice) {
  const indexes = [];
  prices.forEach((seasonalPrice, i) => {
    if (!seasonalPrice.deleted) {
      if (indexEditedSeasonalPrice === i) {
        if (editedSeasonalPrice.date_start !== seasonalPrice.date_start && editedSeasonalPrice.date_end !== seasonalPrice.date_end) {
          if (moment(editedSeasonalPrice.date_start).isSameOrBefore(seasonalPrice.date_end) && moment(editedSeasonalPrice.date_end).isSameOrAfter(seasonalPrice.date_start)) {
            indexes.push(i);
          }
        }
      } else {
        if (moment(editedSeasonalPrice.date_start).isSameOrBefore(seasonalPrice.date_end) && moment(editedSeasonalPrice.date_end).isSameOrAfter(seasonalPrice.date_start)) {
          indexes.push(i);
        }
      }
    }
  });
  return indexes;
}

export default SeasonalPrices;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/rental-ruleset/components/RentalRulesetEditor/SeasonalPricesEditor.jsx